import React, { useCallback } from 'react';
import { NotificationManager, HistoryManager } from '@atlas/core';
import PropTypes from 'prop-types';
import useTranslate from 'common/I18n/Interpreter';

const TransactionCancelButton = ({ transactionId, updateTransactionsAfterCancel }) => {
  const t = useTranslate();
  const cancelHandler = useCallback(() => {
    NotificationManager.display({
      type: 'confirm',
      title: 'withdrawal_cancellation',
      message: 'confirm_withdrawal_cancellation',
      data: {
        confirmLabel: 'cancel',
        closeLabel: 'back',
        onConfirm: () => {
          HistoryManager.cancel(HistoryManager.actions.operation.transaction, transactionId)
            .then(() => {
              NotificationManager.notify({
                type: 'notification',
                status: 'success',
                message: 'transaction_cancel_successful',
              });
              updateTransactionsAfterCancel(transactionId);
            })
            .catch(error => {
              NotificationManager.notify({
                type: 'notification',
                status: 'error',
                message: `transaction_error_${error.code}`,
              });
            });
        },
      },
    });
  }, [transactionId]);

  return <span onClick={cancelHandler}>{t('Cancel transaction')}</span>;
};

TransactionCancelButton.propTypes = {
  transactionId: PropTypes.number.isRequired,
  updateTransactionsAfterCancel: PropTypes.func.isRequired,
};

export default TransactionCancelButton;
